import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Flashlight Off"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-flashlight-off',
    templateUrl: './icon-flashlight-off.component.html',
    styleUrls: ['./icon-flashlight-off.component.scss'],
    standalone: false
})
export class IconFlashlightOffComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
